import {Component, OnInit,Inject,Input} from 'ng-metadata/core';
import {MendeleyToastService} from './mendeleyToast.service';
import {MediaQueries} from "../../../../infra/mediaQueries.service";

@Component({
    selector: 'prm-mendeley-toast',
    templateUrl: 'components/search/actions/mendeleyAction/mendeleyToast/mendeley-toast.html',
})

export class PrmMendeleyToast implements OnInit{
    @Input() public isSuccess  : boolean;
    @Input() public inProgress  : boolean;
    @Input() public title  :  string;

    constructor(private mendeleyToastService: MendeleyToastService,
        @Inject('$mdToast') private $mdToast: ng.material.IToastService,
        private mediaQueries: MediaQueries) {
    }

    ngOnInit() {
    }

    private onDismiss() {
        this.$mdToast.hide();

    }

    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/mendeleyAction/mendeleyToast/mendeleyToast.directive.ts